import sortBy from 'lodash/sortBy'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {domainDropdown} from './domain-picker.module.scss'

type Props = {
  domains: Array<string>
  domainConcept: string
  domainsConcept: string
  currentDomain: string | undefined | null
  onChangeDomain: (domain?: string | null) => void
}

export function DomainPicker(props: Props) {
  const {t} = useSafeTranslation()
  const {domains, domainConcept, domainsConcept, currentDomain, onChangeDomain} = props

  const allDomains = t('GROWTH_PAGE_ALL_DOMAINS_OPTION_TEXT', {domainsConcept})

  const allDomainsItem = {label: allDomains, value: allDomains}

  const domainItems = sortBy(domains).map(domain => ({label: domain, value: domain}))

  const menuItems = [allDomainsItem, ...domainItems]

  const value =
    currentDomain === undefined || currentDomain === null
      ? allDomainsItem
      : {label: currentDomain, value: currentDomain}

  return (
    <div className={domainDropdown}>
      <div data-pii id="domain-picker-dropdown">
        <Dropdown
          labelText={domainConcept}
          options={flatOptions(menuItems)}
          value={value}
          handleChange={newValue => {
            if (newValue === null) return
            onChangeDomain(newValue.value === allDomains ? null : newValue.value)
          }}
        />
      </div>
    </div>
  )
}
